import { Chip, useTheme, type ChipProps } from '@mui/material';
import { composeSx } from '../../utils/composeSx';
import { chipToneColors, type HFChipTone } from './tones';

export type { HFChipTone };

export type HFChipProps = ChipProps & {
  /** Status pill. Pending and warn share amber; complete and pass share green. */
  tone?: HFChipTone;
};

export function HFChip({ sx, tone, color, variant, size, ...props }: HFChipProps) {
  const theme = useTheme();
  const colors = tone ? chipToneColors(tone, theme) : undefined;
  const toneSx = colors
    ? {
        borderRadius: 999,
        bgcolor: colors.bgcolor,
        color: colors.color,
        border: colors.border,
        fontSize: 11,
        fontWeight: 800,
        '& .MuiChip-label': { px: 1, py: 0.5, color: 'inherit' },
      }
    : undefined;

  return (
    <Chip
      {...props}
      size={tone ? (size ?? 'small') : size}
      color={tone ? undefined : color}
      variant={tone ? undefined : variant}
      sx={composeSx(
        {
          height: 'auto',
          '& .MuiChip-label': { px: 1.5, py: 0.5 },
        },
        toneSx,
        sx,
      )}
    />
  );
}
